// src/guide/compte/guide_compte_creer_utilisateurs.js
import {
  guide_tour_init,
  guide_tour_step_start,
  guide_tour_step,
  guide_tour_step_complete,
} from "@/guide/utils/guide_tour_actions";

export async function guide_compte_creer_utilisateurs(langs) {
  let translations;
  try {
    // Charge dynamiquement le JSON correspondant (ex: guide_traduction_fr.json)
    translations = (
      await import(`@/guide/traductions/guide_traduction_${langs}.json`)
    ).default;
  } catch (error) {
    console.error(
      "Erreur lors du chargement des traductions pour la langue",
      langs,
      error
    );
    return;
  }
  const tour = guide_tour_init();

  guide_tour_step_start(
    tour,
    translations,
    translations.compte.utilisateurs.ajouter_utilisateur.nom.titre,
    translations.compte.utilisateurs.ajouter_utilisateur.nom.texte,
    "#nom",
    "bottom"
  );

  guide_tour_step(
    tour,
    translations,
    translations.compte.utilisateurs.ajouter_utilisateur.prenom.titre,
    translations.compte.utilisateurs.ajouter_utilisateur.prenom.texte,
    "#prenom",
    "bottom"
  );

  guide_tour_step(
    tour,
    translations,
    translations.compte.utilisateurs.ajouter_utilisateur.genre.titre,
    translations.compte.utilisateurs.ajouter_utilisateur.genre.texte,
    "#genre",
    "bottom"
  );

  guide_tour_step(
    tour,
    translations,
    translations.compte.utilisateurs.ajouter_utilisateur.poste.titre,
    translations.compte.utilisateurs.ajouter_utilisateur.poste.texte,
    "#poste",
    "bottom"
  );

  guide_tour_step(
    tour,
    translations,
    translations.compte.utilisateurs.ajouter_utilisateur.mail.titre,
    translations.compte.utilisateurs.ajouter_utilisateur.mail.texte,
    "#mail",
    "bottom"
  );

  guide_tour_step(
    tour,
    translations,
    translations.compte.utilisateurs.ajouter_utilisateur.telephone.titre,
    translations.compte.utilisateurs.ajouter_utilisateur.telephone.texte,
    "#telephone",
    "bottom"
  );

  guide_tour_step(
    tour,
    translations,
    translations.compte.utilisateurs.ajouter_utilisateur.mdp.titre,
    translations.compte.utilisateurs.ajouter_utilisateur.mdp.texte,
    "#mdp",
    "bottom"
  );

  guide_tour_step(
    tour,
    translations,
    translations.compte.utilisateurs.ajouter_utilisateur.role.titre,
    translations.compte.utilisateurs.ajouter_utilisateur.role.texte,
    "#role",
    "bottom"
  );
  guide_tour_step_complete(
    tour,
    translations,
    translations.compte.utilisateurs.ajouter_utilisateur
      .valider_creation_utilisateur.titre,
    translations.compte.utilisateurs.ajouter_utilisateur
      .valider_creation_utilisateur.texte,
    "#valider_creation_utilisateur",
    "top"
  );

  tour.start();
}
